<template>
  <a :href="this.getPromoUrl" target="_blank" class="btn btn--full-width btn--cta-red">Kalkuluj</a>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  created () {
    this.$store.dispatch('promoCode', 'get')
  },
  computed: {
    ...mapGetters([
      'getPromoUrl'
    ])
  }
}
</script>

<style lang="scss" src="./calculateButton.scss"></style>



// WEBPACK FOOTER //
// calculateButton.vue?8beddaa2